import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './mainAlertStyles.css';

toast.configure({ position: toast.POSITION.TOP_RIGHT, hideProgressBar: true });
